<template>
  <v-container>
    <div v-if="result">
      <v-row>
        <v-col cols="12" align="center" class="text-h5">
          Your order has been succesfully placed.
        </v-col>
      </v-row>

      <v-row>
        <v-col
          cols="12"
          align="center"
          class="text-subtitle-1 font-weight-bold"
        >
          Order Reference: {{ result.uuid }}
        </v-col>
      </v-row>

      <v-row>
        <v-col
          cols="12"
          align="center"
          class="text-subtitle-1 font-weight-bold"
        >
          <v-btn
            @click="viewPayload"
            dark
            tile
            elevation="0"
            large
            color="#2dc59a"
            >View Payload</v-btn
          >
        </v-col>
      </v-row>
    </div>

    <v-overlay :value="loading">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      result: null,
      dialog: false,
      loading: true,
    };
  },

  beforeMount() {
    if (this.$route.query.consent) {
      this.createPayment(this.$route.query.consent, this.$route.query.uuid);
    }

    if (this.$route.query.paymentRequestId) {
      this.getHostedPaymentStatus(this.$route.query.paymentRequestId, this.$route.query.uuid);
    }

    if (this.$route.query.uuid && this.$route.query.mobile) {
      this.getTransactionStatus(this.$route.query.uuid);
    }
  },

  methods: {
    createPayment(consent, uuid) {
      this.$axios({
        method: "post",
        url: "/create-payment",
        data: {
          merchantUuid: process.env.VUE_APP_BOODIL_MERCHANT_UUID,
          uuid: uuid,
          consentToken: consent,
        },
      })
        .then((res) => {
          this.result = res.data;
          this.loading = false;
        })
        .catch((e) => {
          console.log(e);
          this.loading = false;
        });
    },
    getHostedPaymentStatus(paymentRequestId, uuid) {
      this.$axios({
        method: "post",
        url: "/get-hosted-payment-status",
        data: {
          merchantUuid: process.env.VUE_APP_BOODIL_MERCHANT_UUID,
          uuid: uuid,
          paymentRequestId: paymentRequestId,
        },
      })
        .then((res) => {
          this.result = res.data;
          this.loading = false;
        })
        .catch((e) => {
          console.log(e);
          this.loading = false;
        });
    },
    getTransactionStatus(uuid) {
      this.$axios({
        method: "post",
        url: "/get-transaction-status",
        data: {
          merchantUuid: process.env.VUE_APP_BOODIL_MERCHANT_UUID,
          uuid: uuid,
        },
      })
        .then((res) => {
          this.result = res.data;
          this.loading = false;
        })
        .catch((e) => {
          console.log(e);
          this.loading = false;
        });
    },
    viewPayload() {
      this.$router.push({ name: "Payload", params: { payload: this.result } });
    },
  },
};
</script>

<style>
</style>